export default __webpack_public_path__ + "static/media/sanjivani-tea.64364db5.png";